<template>
  <div class="main">
    <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="gainMenu" current="MADE Charts" />
      <div class="r action-btn-box" v-show="false"></div>
      <xy-toolbox-menu class="r" v-show="gainData.length > 0" style="width:90px;">
        <xy-toolbox-menu-item icon="excel" @click="exportExcel"
          >Excel导出
        </xy-toolbox-menu-item>
      </xy-toolbox-menu>    
    </div>
    <div style="display:flex">
      <div style="text-align:right;padding-right:10px;width:100%;">
        <span v-show="marketTags.length>0">已选细分市场：</span>
        <el-tag v-for="item in marketTags" :key="item" style="margin-left:4px"> {{item}}</el-tag>
      </div>
    <div style="margin-right:30px; text-align:right;width:100%;">
 

   <el-select
            placeholder="请选择时间段"
            v-model="selectedMonth"
            filterable
                @change="onSelectMarket"
          >
            <el-option
              v-for="item in quickMonth"
              :label="item"
              :key="item"
              :value="item"
            ></el-option>
          </el-select> &nbsp;
       <el-select
            v-model="selectedMarkets"
            placeholder="请选择细分市场"
            filterable
            clearable
            multiple
            allow-create
            @change="onSelectMarket"
            ref = "refm"
          >
            <template>
              <el-option
                v-for="item in quickTags"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </template>
          </el-select>
        
    </div>
    </div>
    <div v-if="gainData.length > 0" style="margin-top: 20px ;margin-right:30px;" >
      <el-collapse v-model="activeNames" @change="handleChange" >
        <el-collapse-item title="价格指数" name="1" style="padding:10px">
           <CommonCharts chartName="price_index"  v-bind:options.sync="tpChartsOptions"></CommonCharts>
        </el-collapse-item>
              <el-collapse-item title="优惠指数" name="2" style="padding:10px">
                       <CommonCharts chartName="discount_index"  v-bind:options.sync="discountOptions"></CommonCharts>
        </el-collapse-item>
              <el-collapse-item title="表格数据" name="3" style="padding:10px">

                     <el-table
        style="width: 100%; min-height: 600px; background-color: #fff; margin:10px;"
        ref="resultTable"
        :data="gainData"
        tooltip-effect="dark"
        height="600"
        :paginationShow="true"
      >
        <el-table-column label="月份" prop="month"></el-table-column>
        <el-table-column label="当月TP" prop="current_tp"></el-table-column>
        <el-table-column
          label="价格指数"
          prop="price_index"
          :formatter="priceIndexFormatter"
        ></el-table-column>
        <el-table-column label="TP同比" prop="mom_tp"  :formatter="indexFormatter"></el-table-column>

        <el-table-column label="当月优惠" prop="discount"></el-table-column>
        <el-table-column
          label="优惠指数"
          prop="discount_index"
          :formatter="priceIndexFormatter"
        ></el-table-column>
        <el-table-column label="当月同比" prop="mom_discount"  :formatter="indexFormatter"></el-table-column>
      </el-table>
        </el-collapse-item>
      </el-collapse>
     
 
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";
import chartsOptions from "@/store/local_data/ChartsTemplate";
import CommonCharts from "@/components/charts/CommonCharts.vue";
import store from '../store/store';
export default {
  name: "gaincharts",
  components: { CommonCharts },
  data() {
    return {
      activeNames:["1","2","3"],
      selectedMonth: "今年",
      quickMonth: ["2020年至今", "2021年至今", "今年"],
      quickTags: ["整体","A0","A",  "B", "C", "Sedan","SUV","MPV","A0_SUV", "A_SUV","B_SUV", "C_SUV"],
      selectedMarkets: [],
      currentModuleName: "Gain",
      dataSource: "乘联会销量管理",
      daterange: ["2022-01", "2022-01"],
      tpChartsOptions: {},
      discountOptions:{},
    };
  },
  methods: {
    ...mapActions("gain", ["getMarketsByName", "queryGainData"]),
    ...mapMutations("gain", ["clearGainData","clearMarketTags"]),
    onSelectMarket() {
        var str = this.selectedMarkets.join(";");
        var postData = { name: str };
       this.getMarketsByName({ params: postData });
       this.getGainData();

       setTimeout(() => {
         this.$refs.refm.blur();
       }, 50);
    },
    setDataRange() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      var m = nowDate.getMonth() + 1;
      m = m < 10 ? "0" + m : m;

      var endMonth = year + "-" + m;
      if (this.selectedMonth == "今年") {
        this.daterange = [year + "-01", endMonth];
      } else if (this.selectedMonth == "2020年至今") {
        this.daterange = ["2020-01", endMonth];
      } else if (this.selectedMonth == "2021年至今") {
        this.daterange = ["2021-01", endMonth];
      }
    },
    getGainData() {
      this.setDataRange();
      if(this.selectedMarkets.length<=0)
      {
        this.clearGainData();
        this.clearMarketTags();
       // alert(JSON.stringify(this.gainData));
        return ;
      }
      var tags = this.selectedMarkets.join(";");
      let postData = {
        marketTags: tags,
        startMonth: this.daterange[0],
        endMonth: this.daterange[1],
      };
      var self = this;
      this.queryGainData({ params: postData ,handle:(res)=>{

        this.setPriceOption();
        this.setDiscountOptions();
      }});
    },
    indexFormatter(row, column, cellValue) {
      return (cellValue * 100).toFixed(0) + "%";
    },
     priceIndexFormatter(row, column, cellValue) {
      return (cellValue ).toFixed(2) ;
    },
    exportExcel() {
      let name = this.marketTags + this.selectedMonth;
      var worksheet = XLSX.utils.json_to_sheet(this.gainData);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, name);
      XLSX.writeFile(new_workbook, name + "_.xlsx");
    },
    setPriceOption() {   
      let opts =  chartsOptions.gain_price;
       opts.series[0].data =[];
      opts.series[1].data=[];
       opts.series[2].data=[];
     
       let s2020 = this.gainData.filter(x =>  x.month.indexOf('2020')>=0).map(z=>(z.price_index).toFixed(2) );   
       let s2021 = this.gainData.filter(x =>  x.month.indexOf('2021')>=0).map(z=>(z.price_index).toFixed(2) );   
       let s2022 =  this.gainData.filter(x =>  x.month.indexOf('2022')>=0).map(z=>(z.price_index).toFixed(2) ); 
       var chk = function(year,year_arr,opt) {
           if(year_arr.length==0)
            {
               let idx = opt.legend.data.indexOf(year);
               if(idx>=0)
                  opts.legend.data.splice(idx, 1);
            }else{
              let idx = opt.legend.data.indexOf(year);
               if(idx<=0)
                  opts.legend.data.push(year);
            }
       };
        chk('2020',s2020,opts);
        chk('2021',s2021,opts);
        chk('2022',s2022,opts);
        opts.series[0].data= s2020;
        opts.series[1].data= s2021;
        opts.series[2].data= s2022;  
        this.tpChartsOptions =opts;
   
    },
    setDiscountOptions(){
      var opts =    chartsOptions.gain_discount;
       opts.series[0].data =[];
       opts.series[1].data=[];
       opts.series[2].data=[];
     
       let s2020 = this.gainData.filter(x =>  x.month.indexOf('2020')>=0).map(z=>(z.discount_index).toFixed(2) );   
       let s2021 = this.gainData.filter(x =>  x.month.indexOf('2021')>=0).map(z=>(z.discount_index).toFixed(2) );   
       let s2022 =  this.gainData.filter(x =>  x.month.indexOf('2022')>=0).map(z=>(z.discount_index).toFixed(2) ); 
       var chk = function(year,year_arr,opt) {
           if(year_arr.length==0)
            {
               let idx = opt.legend.data.indexOf(year);
               if(idx>=0)
                  opts.legend.data.splice(idx, 1);
            }else{
              let idx = opt.legend.data.indexOf(year);
               if(idx<=0)
                  opts.legend.data.push(year);
            }
       };
        chk('2020',s2020,opts);
        chk('2021',s2021,opts);
        chk('2022',s2022,opts);
        opts.series[0].data= s2020;
        opts.series[1].data= s2021;
        opts.series[2].data= s2022;  
      this.discountOptions =opts;
   

    },
    handleChange(){

    }
    // 进入分析
  },
  computed: {
    ...mapGetters("gain", ["marketTags", "gainData"]),
  },
  mounted() {

  //  alert(chartsOptions);
  },
  watch: {
    gainData(newValue) {
      
    },
  },
};
</script>
<style>
</style>